import ShopPremiumFolders from './ShopPremiumFolders';

export default ShopPremiumFolders;
